import React from 'react';
import {
    Button,
    Grid, IconButton,
    makeStyles,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useTranslation} from "react-i18next";
import {Trash} from "react-feather";
import { SHIPPER_PARCELSHOP_SUFFIX, SHIPPER_SHORTCUTS } from 'constants/shippers';

const useStyles = makeStyles((theme) => ({
    root: {},
    icon: {
        padding: '10px',
        marginTop: '5px'
    },
    footer: {
        marginTop: 0,
        marginBottom: 0
    }
}));

const isPacketaCourier = (neoshipShippers, neoshipShipperId) => {
    if (!neoshipShipperId) return false;
    if (String(neoshipShipperId).endsWith(SHIPPER_PARCELSHOP_SUFFIX)) return false;
    const shipper = neoshipShippers.find(s => s.id == neoshipShipperId);
    return shipper && shipper.shortcut && shipper.shortcut.toUpperCase() === SHIPPER_SHORTCUTS.PACKETA;
};

const ConnectorFormShipperMapping = ({ neoshipShippers, eshopShippers, shipperMappings, setShipperMappings, carriers, errors, showCarrierType, ...rest }) => {
    const {t} = useTranslation('connector');
    const classes = useStyles();

    const handleChange = (event, value, index) => {
        let data = [...shipperMappings];
        data[index][event.target.name] = value;
        if (showCarrierType && event.target.name === 'neoship_shipper') {
            if (!isPacketaCourier(neoshipShippers, value)) {
                data[index].carrier_type = null;
            }
        }
        setShipperMappings(data);
    }

    const addShipperMapping = (event) => {
        event.preventDefault();
        const newMapping = { neoship_shipper: '', eshop_shipper: '' };
        if (showCarrierType) {
            newMapping.carrier_type = null;
        }
        setShipperMappings([...shipperMappings, newMapping]);
    }

    const removeShipperMapping = (event, index) => {
        event.preventDefault();
        let values = [...shipperMappings];
        values.splice(index, 1);
        setShipperMappings(values);
    }

    return (
        <React.Fragment>
            {
                shipperMappings.map((item, index) => (
                    <Grid container spacing={2} key={'shipper-mappings-cointainer-'+index}>
                        <Grid item xs={3}>
                            {neoshipShippers && neoshipShippers.length ?
                                <Autocomplete
                                    id="combo-box-neoship_shipper"
                                    name='neoship_shipper'
                                    value={neoshipShippers.find(s => s.id == item.neoship_shipper) || ''}
                                    options={neoshipShippers}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => <TextField {...params} label={t('label.neoship_shipper')} />}
                                    onChange={(event, value) => handleChange({target: {name: 'neoship_shipper'}}, value.id, index) }
                                /> :
                                <TextField id="connector-neoship_shipper" label={t('label.neoship_shipper')} variant="outlined" value={neoshipShippers.find(s => s.id === item.neoship_shipper) || ''}  onChange={(event) => handleChange(event, event.target.value, index) } />
                            }
                        </Grid>
                        <Grid item xs={3}>
                            {eshopShippers && eshopShippers.length ?
                                <Autocomplete
                                    id="combo-box-eshop_shipper"
                                    name='eshop_shipper'
                                    value={eshopShippers.find(s => s.id == item.eshop_shipper) || null}
                                    options={eshopShippers}
                                    getOptionLabel={(option) => (option && option.name) ? option.name : ''}
                                    renderInput={(params) => <TextField {...params} label={t('label.eshop_shipper')} />}
                                    onChange={(event, value) => handleChange({target: {name: 'eshop_shipper'}}, value ? value.id : '', index) }
                                /> :
                                <TextField id="connector-shipper-eshop_shipper" label={t('label.eshop_shipper')} variant="outlined" value={item.eshop_shipper ?? ''} onChange={(event) => handleChange(event, event.target.value, index)} />
                            }
                        </Grid>
                        {showCarrierType && isPacketaCourier(neoshipShippers, item.neoship_shipper) && carriers && carriers.length > 0 &&
                            <Grid item xs={3}>
                                <Autocomplete
                                    id={`combo-box-carrier_type-${index}`}
                                    name='carrier_type'
                                    value={carriers.find(c => c.packeta_id === item.carrier_type) || null}
                                    options={carriers}
                                    groupBy={(option) => option.state || ''}
                                    getOptionLabel={(option) => (option && option.name) ? option.name : ''}
                                    renderInput={(params) => <TextField {...params}
                                        label={t('label.carrier_type')}
                                        error={!!(errors && errors[index] && errors[index].carrier_type)}
                                        helperText={errors && errors[index] && errors[index].carrier_type}
                                    />}
                                    onChange={(event, value) => handleChange({target: {name: 'carrier_type'}}, value ? value.packeta_id : null, index) }
                                />
                            </Grid>
                        }
                        <Grid item xs={1} style={{display: 'table-cell', verticalAlign: 'center'}}>
                            <IconButton
                                aria-label={t('button.delete')}
                                size="small"
                                className={classes.icon}
                                onClick={(event) => { removeShipperMapping(event, index) }}
                                color="secondary"
                                type="button"
                            >
                                <Trash />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))
            }
            <Grid container spacing={5} className={classes.footer}>
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" type="button" onClick={(event) => { addShipperMapping(event); }} >{t('button.add_shipper')}</Button>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default ConnectorFormShipperMapping;